<template>
  <div id="noon-report-header">
    <div>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12" class="mr-4">
          <v-date-picker
            v-if="selectFormVesselNameProps"
            v-model="selectedRangeModel"
            :columns="3"
            :masks="masks"
            is-range
          >
            <template v-slot="{ inputValue, togglePopover }">
              <div class="flex items-center noon-report-calendar">
                <feather-icon icon="CalendarIcon" svgClasses="h-8 w-8" class="m-2"
                              @click="togglePopover()"></feather-icon>
                <span class="aisea-text-30-400-black" @click="togglePopover()">{{
                    inputValue.start
                  }} ~ {{ inputValue.end }}</span>
              </div>
            </template>
          </v-date-picker>
        </vs-col>
      </vs-row>
    </div>
    <div class="mt-8">
      <vs-row vs-w="6">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3" class="mr-4">
          <treeselect v-if="selectFormVesselNameProps" v-model="selectedVesselNameModel"
                      :options="selectFormVesselNameProps.options"
                      :multiple="selectFormVesselNameProps.multiple" placeholder="すべての船舶" :limit="treeselectLimit"
                      :limitText="count => `+${count}`" :noOptionsText="noOptionsText" class="mr-4"></treeselect>
          <treeselect v-if="selectFormSenderProps" v-model="selectedSenderModel"
                      :options="selectFormSenderProps.options"
                      :multiple="selectFormSenderProps.multiple" placeholder="すべての送信者" :limit="treeselectLimit"
                      :limitText="count => `+${count}`" :noOptionsText="noOptionsText" class="mr-4"></treeselect>
          <treeselect v-if="selectFormStatusProps" v-model="selectedStatusModel"
                      :options="selectFormStatusProps.options"
                      :multiple="selectFormStatusProps.multiple"
                      placeholder="すべてのステータス" :limit="treeselectLimit" :limitText="count => `+${count}`"
                      :noOptionsText="noOptionsText">
            <div slot="value-label" slot-scope="{ node }">{{ node.label }}</div>
            <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
              <span :style="getStyleObject(node.label)">{{ node.label }}</span>
            </label>
          </treeselect>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import {DeviceInfoMixin, ColorMixin} from "@/mixins";
import moment from "moment-timezone";
import _ from "lodash";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {createNamespacedHelpers} from "vuex";

const {mapActions, mapMutations, mapState, mapGetters} = createNamespacedHelpers("vesselNoonReportList");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    Treeselect,
  },
  data() {
    return {
      masks: {
        title: 'YYYY年 MMM',
        input: 'YYYY年MM月DD日',
      },
      minDate: moment().subtract(90, 'days').toDate(),
      treeselectLimit: 1,
      noOptionsText: "選択項目が見つかりません",
    }
  },
  watch: {
    currentPage() {
      this.fetchReports();
    },

    dateRange(newVal, oldVal) {
      if (oldVal === null) return
      if (newVal === null) {
        this.SET_DATE_RANGE(oldVal);
      } else {
        this.fetchReports();
      }
    },

    selectedVesselNames(newVal, oldVal) {
      this.fetchReports();
    },

    selectedSenders(newVal, oldVal) {
      this.fetchReports();
    },

    selectedStatus(newVal, oldVal) {
      this.fetchReports();
    },
  },
  computed: {
    ...mapGetters([
      "dateRangeUTC", "dateRangeJST", "selectFormVesselNameProps", "selectedVesselNames", "selectFormSenderProps", "selectedSenders",
      "selectFormStatusProps", "selectedStatus", "statusColor"
    ]),

    ...mapState([
      "dateRange",
      "searchParameters",
      "currentPage",
      "paginationPageSize",
      "selectedVesselNames",
      "selectedSenders",
      "selectedStatus"
    ]),

    selectedRangeModel: {
      get() {
        return this.dateRangeJST
      },
      set(val) {
        if (this.validateDataRange(val)) {
          this.openRangAlert()
        } else {
          let range = {
            start: moment(val.start).format("YYYY-MM-DD"),
            end: moment(val.end).format("YYYY-MM-DD")
          }
          this.SET_CURRENT_PAGE(0)
          this.SET_DATE_RANGE(range);
        }
      }
    },

    selectedVesselNameModel: {
      get() {
        return this.selectedVesselNames
      },
      set(val) {
        this.SET_CURRENT_PAGE(0)
        this.SET_SELECTED_VESSEL_NAMES(val);
      }
    },

    selectedSenderModel: {
      get() {
        return this.selectedSenders
      },
      set(val) {
        this.SET_CURRENT_PAGE(0)
        this.SET_SELECTED_SENDERS(val);
      }
    },

    selectedStatusModel: {
      get() {
        return this.selectedStatus
      },
      set(val) {
        this.SET_CURRENT_PAGE(0)
        this.SET_SELECTED_STATUS(val);
      }
    },
  },
  methods: {
    ...mapActions(["getReports", "getReportSearchParameter"]),

    ...mapMutations([
      "SET_DATE_RANGE",
      "SET_CURRENT_PAGE", "SET_SELECTED_VESSEL_NAMES",
      "SET_SELECTED_SENDERS", "SET_SELECTED_STATUS"]),

    getStyleObject(val) {
      let color = this.statusColor(val)
      let styleObject = {
        "color": color,
        "padding": "4px",
        "borderRadius": "4px",
        "backgroundColor": `${color}20`,
        "fontSize": "12px"
      }
      return styleObject
    },

    clickPrint() {
      this.$emit("clickButton");
    },

    fetchReports: _.debounce(async function () {
      await this.getReports();
    }, 500),

    validateDataRange(inputRage) {
      const from = moment(inputRage.start);
      const to = moment(inputRage.end);
      const elapsedDate = to.diff(from, 'days')
      return elapsedDate > 90
    },

    openRangAlert() {
      this.$vs.dialog({
        color: "danger",
        title: "日付範囲",
        text: "日付範囲が長すぎます。日付範囲は90日以下を設定してください。",
        acceptText: "OK",
        accept: this.rollbackRange
      });
    },

    rollbackRange() {
      this.SET_DATE_RANGE(null);
    }

  },
  async created() {
  },

  async mounted() {
    this.$nprogress.start()
    await this.getReportSearchParameter();
    this.$nprogress.set(0.5);
    await this.fetchReports();
    this.$nprogress.set(1.0);
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-header {
  --vs-primary: 3, 155, 229;
  font-family: $aisea-font-family;

  .vue-treeselect__control {
    width: 240px;
    height: 36px;
  }

  .filter-select {
    min-width: 150px;

    .vs__dropdown-toggle {
      border-radius: 5px;
      min-height: 36px;
    }

    .vs__dropdown-option--selected {
      background-color: rgba($aisea-blue, 0.1);
      color: $aisea-dark-gray !important;
    }
  }

  .vs__selected {
    padding: 4px 8px;
    border-radius: 16px;
    border: none;
  }

  .calender-area {
    .send-date-range-calender {
      width: 128px;
      padding: 8px;
    }
  }

  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }

  .vue-treeselect--open .vue-treeselect__control {
    border-top-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__menu {
    box-shadow: 2px 5px 10px 0.5px #00000026;
    border-bottom-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__multi-value-item {
    color: $aisea-blue !important;
  }

  .noon-report-calendar {
    cursor: pointer;
  }
}
</style>
